import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { Currency } from 'utils/Currency';
import { HomePrice } from 'content/products/uhHome';
import { HomeFaqData } from 'components/uh-home/faq';
import { generateProductSchema, generateFAQSchema, generateBreadcrumbSchema } from 'lib/seo/schema';
import { extractTextFromJSX } from 'utils/extractTextFromJSX';
import { getAssetUrl } from 'lib/config/assetUrls';

type JsonLdObject = Record<string, unknown>;

interface HomePricingSchemaParams {
  countryCode: string;
  store: ShopifyStore;
  currency: Currency;
}

export const getHomePricingSchemas = ({
  countryCode,
  store,
  currency,
}: HomePricingSchemaParams): JsonLdObject[] => {
  const codeUpper = (countryCode || 'US').toUpperCase();
  const codeLower = codeUpper.toLowerCase();

  const actualPrice = HomePrice[store] ?? 599;
  const currencyString = currency.toUpperCase();

  const productSchema = generateProductSchema({
    name: 'Ultrahuman Home',
    description: 'A quiet yet powerful sleep monitor to help you rest better.',
    imageUrl: getAssetUrl('/web_v2/home/buy/desktop/pricing_carousel_b.png'),
    brand: 'Ultrahuman',
    category: 'Smart Home Device',
    price: actualPrice,
    currency: currencyString,
    country: codeUpper,
    availability: 'InStock',
    url: `https://www.ultrahuman.com/${codeLower}/home/buy`,
    rating: {
      ratingValue: 4.6,
      reviewCount: 1200,
    },
  });

  const faqItems = HomeFaqData.map((faq) => ({
    question: faq.title,
    answer: extractTextFromJSX(faq.description) || 'Home FAQ answer',
  })).filter((item) => item.question.trim().length > 0);

  const faqSchema = generateFAQSchema(faqItems);

  const breadcrumbSchema = generateBreadcrumbSchema([
    {
      name: 'Home',
      url: 'https://www.ultrahuman.com',
    },
    {
      name: 'Ultrahuman Home',
      url: 'https://www.ultrahuman.com/home',
    },
    {
      name: 'Buy Ultrahuman Home',
      url: `https://www.ultrahuman.com/${codeLower}/home/buy`,
    },
  ]);

  return [productSchema, faqSchema, breadcrumbSchema];
};


